import { render, staticRenderFns } from "./disponibilita.vue?vue&type=template&id=bb23f090&scoped=true&"
import script from "./disponibilita.vue?vue&type=script&lang=js&"
export * from "./disponibilita.vue?vue&type=script&lang=js&"
import style0 from "./disponibilita.vue?vue&type=style&index=0&id=bb23f090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb23f090",
  null
  
)

export default component.exports